export function dataInRequest(params = {}) {
  return {
    type: '@operacaoTotalizadorVeiculo/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@operacaoTotalizadorVeiculo/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoTotalizadorVeiculo/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@operacaoTotalizadorVeiculo/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@operacaoTotalizadorVeiculo/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@operacaoTotalizadorVeiculo/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@operacaoTotalizadorVeiculo/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@operacaoTotalizadorVeiculo/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoTotalizadorVeiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoTotalizadorVeiculo/RECORD_FILTERING',
    payload: { params },
  };
}
